import { SidebarButton } from "@shared/Sidebar";
import { getLauncherUrl } from "../../config/external-apps";
import { isSSOSession } from "@shared/GoogleLoginButton/user-slice/auto-login";

export const BackToLauncher = () => {
  if (!isSSOSession()) return null;

  const handleClick = () => {
    if (window.opener && !window.opener.closed) {
      // Tab was opened by Polynator: close this tab and return focus to the opener.
      window.close();
    } else {
      // Tab was opened directly (no opener): navigate to the launcher.
      window.location.href = getLauncherUrl();
    }
  };

  return (
    <SidebarButton
      hoverText="Launcher"
      onClick={handleClick}
      data-testid="back-to-launcher"
    >
      <span style={{ fontSize: "18px" }}>⬅</span>
    </SidebarButton>
  );
};
